import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import { I18nProvider } from "@/context/I18nContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import RoleSelect from "@/pages/RoleSelect";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Welcome from "@/pages/Welcome";
import Dashboard from "@/pages/Dashboard";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";import PostListing from "@/pages/PostListing";
import Messages from "@/pages/Messages";
import Notifications from "@/pages/Notifications";
import Orders from "@/pages/Orders";
import Responses from "@/pages/Responses";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Profile from "@/pages/Profile";
import PublicListing from "@/pages/PublicListing";
import CommunityIssues from "@/pages/CommunityIssues";
import ReportIssue from "@/pages/ReportIssue";
import IssueDetail from "@/pages/IssueDetail";
import AdminIssues from "@/pages/AdminIssues";
import CreatePostChooser from "@/pages/CreatePostChooser";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center text-emerald-700">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <NotificationsProvider>{children}</NotificationsProvider>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/p/:id" element={<PublicListing />} />
      <Route path="/role" element={<RoleSelect />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/welcome" element={<Protected><Welcome /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/marketplace" element={<Protected><Marketplace /></Protected>} />
      <Route path="/marketplace/:id" element={<Protected><ListingDetail /></Protected>} />
      <Route path="/post" element={<Protected><CreatePostChooser /></Protected>} />
      <Route path="/post/:kind" element={<Protected><PostListing /></Protected>} />
      <Route path="/edit/:editingId" element={<Protected><PostListing /></Protected>} />
      <Route path="/messages" element={<Protected><Messages /></Protected>} />
      <Route path="/messages/:threadId" element={<Protected><Messages /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/orders" element={<Protected><Orders /></Protected>} />
      <Route path="/responses" element={<Protected><Responses /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/community" element={<Protected><CommunityIssues /></Protected>} />
      <Route path="/community/report" element={<Protected><ReportIssue /></Protected>} />
      <Route path="/community/:id" element={<Protected><IssueDetail /></Protected>} />
      <Route path="/admin/community" element={<Protected><AdminIssues /></Protected>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
          <PwaInstallPrompt />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
